import {useNavigate} from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { useOpportunity } from "../../../hook/partner/opportunity.partner.hook";
import { useRenewalOffer } from "../../../hook/partner/renewals.partner.hook";
import { useRenewalsStore } from "../../../store/renewals.store";
import { NavLink } from "react-router";
import number_format from "../../../utils/number_format";
import {PartnerApi} from "../../../api/partner.api";
import { useTranslation } from "../../../hooks/useTranslation";

export default function RenewalOfferForm({ handleClose, renewal = null }) {
  const { t } = useTranslation();
  const [selectedProducts, setSelectedProducts] = useState({});
  const [selectedLicences, setSelectedLicences] = useState({});
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const token = useAuthStore((state) => state.token);
  const renewalOfferMutation = useRenewalOffer();
  const renewalOffer = useRenewalsStore((state) => state.renewalOffer);

  const getItems = () => {
    const items = [];

    const keys = Object.keys(selectedLicences);
    keys.forEach((key) => {
      items.push({
        product_id: selectedLicences[key]?.product_id,
        quantity: 1,
        sn: renewalOffer[key].sn,
      });
    });

    return items;
  };

  const renewalOfferDelete = (e) => {
    e.preventDefault();

    return renewalOfferSend("delete");
  };
  const renewalOfferAdd = (e) => {
    e.preventDefault();

    return renewalOfferSend("add");
  };

  const renewalOfferSend = (type) => {
    const data = {
      token: token,
      items: getItems(),
      company_id: renewal.company_id,
      expire_date: renewal.expire_date,
    };
    let result = null;
    if (type === "add") {
      result = PartnerApi.renewalOfferAdd(data);
    } else if (type === "delete") {
      result = PartnerApi.renewalOfferDelete(data);
    }

    if (!result) {
      return;
    }

    result.then((result) => {
      if ("error" in result) {
        setError(result.error);
        return;
      }

      handleClose();
      if ("opportunity_id" in result) {
        return navigate("/prilezitost/" + result.opportunity_id);
      }

      return false;
    });
  }

  useEffect(() => {
    setSelectedLicences({});
    setSelectedProducts({});
    console.log(selectedLicences);
    if (renewal && renewal?.company_id && renewal?.expire_date) {
      renewalOfferMutation.mutate({
        expire_date: renewal.expire_date,
        company_id: renewal.company_id,
        token,
      });
    }
  }, [renewal]);

  useEffect(() => {
    const keys = Object.keys(selectedProducts);

    keys.forEach((key) => {
      if (key in selectedLicences) {
        selectedLicences[key] = renewalOffer[key].offer[selectedProducts[key]];
      }
    });
    setSelectedLicences(selectedLicences);
  }, [selectedProducts]);

  if (renewalOfferMutation.isLoading) {
    return <>{t("common.loading")}</>;
  }

  console.log(selectedLicences);

  const addId = (e, rindex) => {
    if (e.target.checked) {
      setSelectedLicences({
        ...selectedLicences,
        [rindex]:
          renewalOffer[rindex].offer[
            rindex in selectedProducts ? selectedProducts[rindex] : 0
          ],
      });
    } else {
      delete selectedLicences[rindex];
      setSelectedLicences(selectedLicences);
    }
  };

  const changeProduct = (e, rindex) => {
    setSelectedProducts({ ...selectedProducts, [rindex]: e.target.value });
  };

  return (
    <div>
      {error && <p className="alert alert-danger">{error}</p>}

      {renewalOffer?.length > 0 ? (
        <div className="dt-container dt-bootstrap5 dt-empty-footer">
          <div id="" className="table-responsive">
            <table
              className="table align-middle table-bordered fs-6 gy-5 xxxdataTable"
              style={{ width: "100%" }}
            >
              <thead>
                <tr className="text-start align-middle text-gray-500 fw-bold fs-7 text-uppercase gs-0">
                  <th>&nbsp;</th>
                  <th>{t("renewals.licenseExtension")}</th>
                  <th>{t("renewals.extendWith")}</th>
                </tr>
              </thead>
              <tbody>
                {renewalOffer?.map((renewalOpportunity, rindex) => (
                  <tr key={rindex}>
                    <td>
                      <div className="form-check form-check-sm form-check-custom form-check-solid">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          disabled={renewalOpportunity.disabled}
                          value={rindex}
                          onChange={(e) => addId(e, rindex)}
                        />
                      </div>
                    </td>
                    <td>
                      {renewalOpportunity.product_name}
                      <br />
                      <span className="badge badge-primary">
                        {renewalOpportunity.sn}
                      </span>
                    </td>
                    <td>
                      {renewalOpportunity.current_opportunity_id > 0 ? (
                        <div>
                          {t("renewals.alreadyExtendingWithDeal")} &nbsp;
                          <NavLink
                            to={
                              "/prilezitost/" +
                              renewalOpportunity.current_opportunity_id
                            }
                          >
                            {renewalOpportunity.current_opportunity_id}
                          </NavLink>
                        </div>
                      ) : renewalOpportunity.offer?.length > 0 ? (
                        <select
                          className="form-select"
                          onChange={(e) => changeProduct(e, rindex)}
                        >
                          >
                          {renewalOpportunity.offer?.map((offer, oindex) => (
                            <option key={oindex} value={oindex}>
                              {offer.name} (
                              {number_format(offer.eu_price, 2, ",", ".")}
                              &nbsp;
                              {offer.currency})
                            </option>
                          ))}
                        </select>
                      ) : (
                        <>-</>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-10 text-center">
            <button
              className="btn btn-warning"
              onClick={(e) => renewalOfferDelete(e)}
            >
              {t("renewals.markExcluded")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              onClick={(e) => renewalOfferAdd(e)}
            >
              {t("renewals.requestMarked")}
            </button>
          </div>
        </div>
      ) : (
        <p>{t("common.notFound")}</p>
      )}
    </div>
  );
}
